import React from 'react';

import Image from 'react-bootstrap/Image';
import WhatsAppLogo from "../Assets/whatsapp-logo.png"

const WhatsAppShareLink = () => {
    const phoneNumber = '9347113488'; // Optional, can be omitted for general share
    const message = 'Hello! I am interested in your services.';

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className='fixed-bottom end-0 start-auto m-2' style={{ left: "auto" }}
        >
            <Image src={WhatsAppLogo} style={{ width: "50px" }} />
        </a>
    );
};

export default WhatsAppShareLink;
